(function () {
  const normalize = (value) => (value || '').trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');

  if (window.location.pathname === '/search') {
    const term = normalize(new URLSearchParams(window.location.search).get('q'));
    const plusSizeTerms = new Set(['plus size', 'plus sized', 'plus size belt', 'plus size belts', 'plus sized belt', 'plus sized belts']);

    if (plusSizeTerms.has(term)) {
      window.location.replace('/collections/plus-size');
      return;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    /* Replace legacy theme links with their canonical destinations. Redirects remain as a safety net. */
    document.querySelectorAll('a[href="/pages/bulk-gifting"]').forEach((link) => {
      link.setAttribute('href', '/pages/bulk-gifting-new');
    });
    document.querySelectorAll('a[href="/pages/return"], a[href="/pages/cancellation-refund-policy"]').forEach((link) => {
      link.setAttribute('href', '/policies/refund-policy');
    });
    document.querySelectorAll('a[href="/pages/rating"]').forEach((link) => {
      const listItem = link.closest('li');
      if (listItem) listItem.remove();
      else link.remove();
    });

    const checkBtn = document.getElementById('pincode-check-btn');
    const input = document.getElementById('pincode-input');
    const result = document.getElementById('pincode-result');

    if (!checkBtn || !input || !result) return;

    let pincodePromise;
    const loadPincodeData = () => {
      if (!pincodePromise) {
        pincodePromise = fetch('https://cdn.shopify.com/s/files/1/0734/9423/3226/files/pincodes.json?v=1764708408')
          .then((response) => {
            if (!response.ok) throw new Error('Pincode data request failed');
            return response.json();
          });
      }
      return pincodePromise;
    };

    checkBtn.addEventListener('click', async () => {
      const pin = input.value.trim();

      if (!/^\d{6}$/.test(pin)) {
        result.textContent = '❌ Please enter a valid 6-digit pincode';
        result.style.color = 'red';
        return;
      }

      checkBtn.disabled = true;
      result.textContent = 'Checking delivery availability…';
      result.style.color = 'black';

      try {
        const pincodeArray = await loadPincodeData();
        const matches = pincodeArray.filter((item) => String(item['Delivery Pincode']) === pin);

        if (!matches.length) {
          result.textContent = '❌ Not Deliverable';
          result.style.color = 'red';
          return;
        }

        const best = matches.find((item) => item.Zone === 'z_a') || matches[0];
        const city = best['Delivery City'] || 'Serviceable Area';
        const zone = best.Zone || '';
        const courier = best.Courier || 'Available courier';
        const codAvailable = zone === 'z_a';
        const returnAvailable = zone === 'z_a';

        result.style.color = 'black';
        result.innerHTML = `
          <div>✔ Deliverable to <b>${String(city).toUpperCase()}</b></div>
          <div>🚚 Courier: <b>${courier}</b></div>
          <div>📦 Zone: <b>${String(zone).toUpperCase()}</b></div>
          <div>${codAvailable ? '✔ COD Available' : '❌ COD Not Available'}</div>
          <div>${returnAvailable ? '✔ Return Available' : '❌ Return Not Available'}</div>
        `;
      } catch (error) {
        result.textContent = 'Unable to check this pincode right now. Please try again.';
        result.style.color = 'red';
      } finally {
        checkBtn.disabled = false;
      }
    });
  });
})();
